export default __webpack_public_path__ + "static/media/army_11.b9845915.jpg";